<template>
  <div class="modal fade" id="deleteTaskModal" tabindex="-1" aria-labelledby="deleteTaskModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="deleteTaskModalLabel" class="modal-title">Delete Task</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            @click.prevent="resetForm"></button>
        </div>
        <div class="modal-body">Are you sure you want to delete this task?</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click.prevent="resetForm">
            Close
          </button>
          <button type="button" class="btn btn-danger" @click.prevent="deleteTask">
            Delete Task
            <loader :isLoading="isLoading"></loader>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loader from "./loader";
import { Modal } from "bootstrap";
import { getters, mutations } from "../store";
export default {
  data() {
    return {
      modal: null,
      isLoading: false,
    };
  },
  components: {
    loader,
  },
  mounted() {
    this.modal = new Modal(document.getElementById("deleteTaskModal"));
  },
  computed: {
    selectedTask() {
      return getters.selectedTask();
    },
  },
  methods: {
    deleteTask() {
      this.isLoading = true;
      this.$axios
        .delete("/agenda/" + this.selectedTask._id, {})
        .then(({ data: { success, message } }) => {
          this.modal.hide();
          window.scrollTo(0, 0);
          this.isLoading = false;
          if (success) {
            mutations.deleteTask(this.selectedTask);
          }
          this.resetForm();
          mutations.showToast({ success, message });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showModal() {
      this.modal.show();
    },
    resetForm() {
      mutations.selectTask();
    },
  },
};
</script>